export const TRAYS_WIDTH = 300;
export const CONTACT_AND_HEADER_WIDTH = 329;
export const CONTACT_AND_HEADER_TIGHT_WIDTH = 60;
export const LAYOUT_PADDING_WIDTH = 16;
export const MAXIMUM_AGENT_TOOLBAR_WIDTH = 316;
export const SIDE_MENU_WIDTH = 60;
export const CONTACT_SECTION_WIDTH = 269;
export const MINIMUM_HEADER_WIDTH = 53;
export const AGENT_TOOLBAR_CONTAINER_PADDING = 24;
export const CONTACT_SIDE_MENU_CONTAINER_RIGHT_PADDING = 11;
export const CONVER_TAGS_SCROLL_OFFSET = 60;
